import React from 'react'

export const Footer = () => {
	return (
		<div className='footer'>
			<span className='systemStatusIcon blink'>⦿</span><span className='systemStatusText'> System Temporarily Unavailable</span>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/footer.tsx